export function bannerLinkSelector(state){
    const { viewCampaignSelected } = state.createCampaign
    if(viewCampaignSelected) {
      const { allowedActions } = viewCampaignSelected
      return allowedActions ? allowedActions : { BannerLink: false }
    }
    return { BannerLink: false }
}